import { getContext, setContext } from 'svelte'
import { getGlobalTranslation } from './Translations'

export type LocalizedMessage = {
      default: string|any
      [keyof: string]: string|any
}

type Constructor<T> = T extends new (...p: infer P) => infer R ? P : never

export class translate {
      localeContext: LocaleContext

      constructor(localeContext: LocaleContext) {
            this.localeContext = localeContext
            return this
      }

      translate(message: LocalizedMessage) {
            if (message[this.localeContext.locale]) return message[this.localeContext.locale]
            return message['default']
      }

      get ŧ() {
            return (msg: LocalizedMessage) => this.translate(msg)
      }
}

const LOCALE = 'LOCALE'

export function getLocaleContext(): LocaleContext {
      return getContext(LOCALE)
}

export function createLocaleContext(...args: Constructor<typeof LocaleContext>): LocaleContext {
      return setContext(LOCALE, new LocaleContext(...args))
}

export class LocaleContext {
      locale = $state('cs')
      locales = ['cs', 'en']
      translate: translate
      defaultLocale = $state('cs')

      currentPage: ReturnType<typeof this.getLocaleTouple> = $state([])

      constructor(defaultLocale: string = '') {
            if (this.locales.includes(defaultLocale)) {
                  this.defaultLocale = defaultLocale
                  this.locale = defaultLocale
            }
            this.translate = new translate(this)

            return this
      }

      getLocale() {
            return this.locale
      }

      setLocale(locale: string) {
            if (!this.locales.includes(locale)) return
            this.locale = locale
            return this
      }

      setCurrentPage( touple: ReturnType<typeof this.getLocaleTouple>) {
        this.currentPage = touple
        return this
      }

      get ŧ() {
            return (msg: LocalizedMessage) => this.translate.ŧ(msg)
      }

      //ŧ( message: LocalizedMessage ) {
      //  if( message[this.locale] ) return message[this.locale]
      //  return message['default']
      //}

      getLocaleLinkFromTouple(toupe: ReturnType<typeof this.getLocaleTouple>) {
        const slug = toupe.find( v => v.locale === this.locale)
        if( ! slug ) return ""

        return this.getLocaleSlug(slug.slug)
      }

      getLocaleLink(url: string) {
            if (!isRelativeLink(url)) return url
            let prefix = this.locale == this.defaultLocale ? '' : '/' + this.locale
            return prefix + url
      }

      getLocaleSlug(slug: string) {
        let prefix = this.locale == this.defaultLocale ? '' : '/' + this.locale
        return prefix + "/" + slug
  }

      getLocaleTouple(url: string) {
            if (!isRelativeLink(url)) []
            let _url = url.replace(/^\//, "")
            return this.locales.map((locale) => {
                  return {
                        locale: locale,
                        slug: _url,
                        selected: locale == this.locale,
                  }
            })
      }
}

function isRelativeLink(url: string) {
      return url.match(/^\/.*$/)
}

export function translator() {
      const context = getLocaleContext()
      return (msg: LocalizedMessage) => context.ŧ(msg)
}

export function globalTranslator() {
      const context = getLocaleContext()
      return (key: string) => {
            const msg = getGlobalTranslation(key)
            if (msg === null) return key
            return context.ŧ(msg)
      }
}
